import noContent from "icons/no-content.svg";
import noContentBook from "icons/no-content-book.svg";
import React from "react";

const emptyContentHtml = (text, icon) => (
  <div className="content_table__body__no_content_div">
    <div className="content_table__body__no_content_div text">
      <img
        alt="No content icon"
        src={icon || noContent}
        style={{ paddingBottom: "5px" }}
      />
      {text}
    </div>
  </div>
);

export const DictionarySearchEmptyContentNoOccurrences = () =>
  emptyContentHtml(
    "We found no occurrences of the dictionary terms, so no content to display",
    noContentBook
  );
export const DictionarySearchEmptyContent = () =>
  emptyContentHtml(
    "Please select a category or term to display its variation across your documents"
  );
export const EmptyContent = () =>
  emptyContentHtml(
    "Please select a Theme to display its variation across your documents"
  );

export const bold = (checkedItems, text) => {
  const formatString = (string) => {
    return string.replace(/[\[\]\\{}()+*?.$^|]/g, (match) => {
      return `\\${match}`;
    });
  };
  let regEx;
  let replaceMask;
  let uniqueWords;
  checkedItems
    ?.filter((item) => item !== undefined)
    .forEach((item) => {
      regEx = new RegExp(formatString(item), "ig");
      replaceMask = text.match(regEx);
      uniqueWords = replaceMask?.filter(
        (word, indexValue, self) => self.indexOf(word) === indexValue
      );
      uniqueWords?.forEach((uniqueWord) => {
        text = text.replace(
          new RegExp(`\\b${formatString(uniqueWord)}\\b`, "g"),
          `<b>${uniqueWord}</b>`
        );
      });
    });
  return text;
};
